import { render, staticRenderFns } from "./InstallerDashboardMainFeature.vue?vue&type=template&id=56c2112b&scoped=true&"
import script from "./InstallerDashboardMainFeature.vue?vue&type=script&lang=js&"
export * from "./InstallerDashboardMainFeature.vue?vue&type=script&lang=js&"
import style0 from "./InstallerDashboardMainFeature.vue?vue&type=style&index=0&id=56c2112b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c2112b",
  null
  
)

export default component.exports